// Polyfill for closest function. supports IE9+
if (!Element.prototype.closest) {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }
  Element.prototype.closest = function(s) {
    const el = this;
    let ancestor = this;

    if (!document.documentElement.contains(el)) return null;

    do {
      if (ancestor.matches(s)) return ancestor;

      ancestor = ancestor.parentElement;
    } while (ancestor !== null);

    return null;
  };
}
